import { CellRenderer } from 'plugins/types';
import { EndpointFieldRenderer } from '../field-renderers';

export const EndpointCellRenderer: CellRenderer = (props) => <EndpointFieldRenderer {...props} />;
